// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2VvSy","colCheckbox":"styles_colCheckbox__3hUTJ"};